import type { Cell } from '../types.ts'

export type Color = 'black' | 'white'
export type Board = Cell[][]
export type Move = { row: number; col: number }
export type SeededRng = () => number

export interface PlayerContext {
  rng: SeededRng
  // row*BOARD_SIZE+col の Set。ルール上着手禁止のマスを Player 側で除外するために使用
  forbidden?: ReadonlySet<number>
  // 指定された手のみを候補とする（強制配置ルール用）。指定があれば forbidden より優先される
  allowedMoves?: readonly Move[]
}

export interface Player {
  readonly id: string
  readonly name: string
  decide(board: Board, color: Color, ctx: PlayerContext): Move | null
}

// mulberry32: 32bit seed からの再現性ある PRNG
export function createRng(seed: number): SeededRng {
  let s = seed >>> 0
  return () => {
    s = (s + 0x6d2b79f5) >>> 0
    let t = s
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

// 同値候補をタイブレーク（RNG でシャッフル選択）
export function pickBest<T>(
  candidates: { score: number; item: T }[],
  rng: SeededRng
): T | null {
  if (candidates.length === 0) return null
  let bestScore = -Infinity
  for (const c of candidates) if (c.score > bestScore) bestScore = c.score
  const bests = candidates.filter(c => c.score === bestScore)
  return bests[Math.floor(rng() * bests.length)].item
}
